import BasicDateInput from "components/BasicInputs/BasicDateInput";
import Table from "components/Table";
import { indexData } from "forms";
import useDateState from "helpers/useDateState";
import DateFilterHeader from "./DateHeaderFilter";

const DateFilter = () => {
   return(<DateFilterHeader type="journal"/>)
}
export default function Journal() {

    return (
        <div className="wrap-journal">
            <Table type="journal" MidComponent={DateFilter as any} />
        </div>
    );
}
